import { Component, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "./components/SmoothScroll";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Demos from "./pages/Demos";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import { scrollToHash } from "./lib/scroll";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => scrollToHash(hash), 90);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "grid",
            placeItems: "center",
            background: "#0B0D0F",
            color: "#F2F1EE",
            fontFamily: "Inter, sans-serif",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <div>
            <p style={{ marginBottom: 12 }}>Something went wrong.</p>
            <a href="/" style={{ color: "#FF6A1A" }}>
              Back to home
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollManager />
        <Routes>
          <Route
            path="/"
            element={
              <PublicLayout>
                <Home />
              </PublicLayout>
            }
          />
          <Route
            path="/demos"
            element={
              <PublicLayout>
                <Demos />
              </PublicLayout>
            }
          />
          <Route path="/admin" element={<Admin />} />
          <Route
            path="*"
            element={
              <PublicLayout>
                <NotFound />
              </PublicLayout>
            }
          />
        </Routes>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1B1F23",
              border: "1px solid #262B30",
              color: "#F2F1EE",
            },
          }}
        />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
